import Vue from 'vue';

import '@/services/logger';
import '@/services/messageListener';
import filters from '@/filters';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(filters);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    const { language } = store.state.settings;
    this.$store.dispatch('connect', store);
    this.$store.dispatch('getTranslations', language);
  },
}).$mount('#app');
